import { render, staticRenderFns } from "./InputMultiChoice.vue?vue&type=template&id=7be3e7d0&scoped=true&lang=pug"
import script from "./InputMultiChoice.vue?vue&type=script&lang=ts"
export * from "./InputMultiChoice.vue?vue&type=script&lang=ts"
import style0 from "./InputMultiChoice.vue?vue&type=style&index=0&id=7be3e7d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be3e7d0",
  null
  
)

export default component.exports